module.exports = __webpack_public_path__ + "img/2.c8276750.png";